import { askEventSchema, askThreadListSchema, askThreadSchema, } from "@nook/schema";
/**
 * `POST /v1/ask` (block 17) — an event stream. `X-Timezone` is how the agent
 * reads "lately" and "last month" in the asker's own zone.
 */
export function ask(http, body, signal) {
    return http.stream({
        path: "/v1/ask",
        method: "POST",
        body,
        schema: askEventSchema,
        headers: { "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone },
        ...(signal ? { signal } : {}),
    });
}
/** Block 42's history, newest activity first. */
export function listAskThreads(http, cursor) {
    return http.request({
        path: `/v1/ask/threads${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`,
        schema: askThreadListSchema,
    });
}
/** `204`, or `404` for a thread already gone — which `useDeleteAskThread` treats as done. */
export function deleteAskThread(http, id) {
    return http.request({ path: `/v1/ask/threads/${id}`, method: "DELETE", schema: { parse: () => undefined } });
}
export function renameAskThread(http, id, title) {
    return http.request({
        path: `/v1/ask/threads/${id}`,
        method: "PATCH",
        body: { title },
        schema: askThreadListSchema.shape.items.element,
    });
}
export function getAskThread(http, id) {
    return http.request({ path: `/v1/ask/threads/${id}`, schema: askThreadSchema });
}
/** `204`, no body — the same structural parser `deleteNook` uses. */
export function recordAskOpen(http, messageId, nookId) {
    return http.request({
        path: `/v1/ask/messages/${messageId}/opened`,
        method: "PATCH",
        body: { nookId },
        schema: { parse: () => undefined },
    });
}
//# sourceMappingURL=ask.js.map